"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PIECES_TO_EVOLVE = exports.MAX_HEALTH = exports.MAX_LEVEL = void 0;
exports.MAX_LEVEL = 10;
exports.MAX_HEALTH = 100;
exports.PIECES_TO_EVOLVE = 3;
